import { apiClient } from '@app/api';
import {
  GroupForSave,
  GroupFromIndex,
  GroupWithUsers,
  UserForSave,
  UserWithGroup,
} from '@app/core/types/users';
import { Group, Paginated, User } from '@mi-front/core';

export async function fetchUsers(query: any = {}): Promise<Paginated<User>> {
  return apiClient.get(`/users-ca`, {
    params: query,
  });
}

export async function fetchUser(
  userId: string,
  params?: Record<string, any>,
): Promise<UserWithGroup> {
  return apiClient.get(`/users-ca/${userId}`, {
    params,
  });
}

export async function fetchUserWithGroup(userId: string): Promise<UserWithGroup> {
  return apiClient.get(`/users-ca/${userId}`, {
    params: {
      contain: 'group',
    },
  });
}

export async function fetchGroup(groupId: string): Promise<GroupWithUsers> {
  return apiClient.get(`/users/groups/${groupId}`, {
    params: {
      contain: 'users',
    },
  });
}

export async function fetchGroups(): Promise<GroupFromIndex[]> {
  return apiClient.get(`/users/groups`);
}

export function updateUser(userId: string, data: Partial<User>): Promise<User> {
  return apiClient.put(`/users-ca/${userId}`, {
    ...data,
    groupId: data.groupId || null,
  });
}

export function createGroup(data: GroupForSave): Promise<Group> {
  return apiClient.post(`/users/groups`, data);
}

export function updateGroup(groupId: string, data: GroupForSave): Promise<Group> {
  return apiClient.put(`/users/groups/${groupId}`, {
    ...data,
  });
}

export function deleteGroup(groupId: string): Promise<void> {
  return apiClient.delete(`/users/groups/${groupId}`);
}

export function createUser(data: UserForSave): Promise<User> {
  return apiClient.post(`/users-ca`, data);
}

export function deleteUser(userId: string): Promise<void> {
  return apiClient.delete(`/users-ca/${userId}`);
}

export async function getAlertsWhatsappGroup(): Promise<{
  groupInviteLink: string;
}> {
  return apiClient.get(`/alerts/whatsapp-group`);
}
